import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import "ol/ol.css";
import "./assets/styles/_typo.scss";
import Vuebar from "vuebar";
Vue.use(Vuebar);

import upperFirst from "lodash.upperfirst";
import camelCase from "lodash.camelcase";

Vue.config.productionTip = false;

Vue.filter("dateFilter", value => {
  return new Date(value).toLocaleString("pl", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
});

Vue.mixin({
  methods: {
    isNumber(e) {
      const { keyCode, key } = e;
      const allowedKeyCodes = [
        8, // backspace
        46, // delete
        37, // left arrow
        39, // right arrow
        9 // tab
      ];
      if (!e.target.value.includes('.') && !this.isTypeInt && e.target.value.length !== 0) {
        allowedKeyCodes.push(190); // dot
      }
      if (allowedKeyCodes.includes(keyCode)) {
        return;
      }
      if (this.isTypeInt) {
        if (!/[0-9]/.test(key)) {
          e.preventDefault();
        }
      } else {
        const disallowedKeyCodes = [69, 108, 187, 188, 189];
        if (disallowedKeyCodes.includes(keyCode)) {
          e.preventDefault();
        }
        if (!/[0-9]/.test(key)) {
          e.preventDefault();
        }
      }
    }
  }
});

const requireComponent = require.context(
  // The relative path of the components folder
  "./components",
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName);

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  );
});

window.vm = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
